<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      ref="tablaReservas"
      :titulo="$t ('Reservas')"
      icono="mdi-calendar-check"
      tabla="res"
      :campos="['loc+', 'fechoralt-', 'id_empinq', 'id_pas', 'id_zon-', 'fechorini', 'fechorfin', 'plaasi', 'obs-', 'lismat', 'fechoruso', 'id_estres-']"
      :campos-filtrables="['fechorini', 'id_empinq', 'id_pas', 'id_zon', 'fechoruso']"
      :parametros="parametros"
      :objeto-definicion-campos="dc"
      :objeto-registro-formulario="rf"
      busqueda-rapida
      :titulo-crud="$t ('reserva')"
      campo-sujeto-accion="loc"
      :permitir-anadir="permisoEscritura"
      :permitir-modificar="permisoEscritura"
      :permitir-eliminar="permisoEscritura"
      :evento-antes-abrir-formulario-datos="antesAbrirFormulario"
      :evento-error-api="eventoErrorAPI"
      :item-class="obtenerItemClassTablaDatos"
    >
      <template v-slot:debajo-titulo>
        <v-tabs fixed-tabs background-color="#D7CCD7" v-model="tabSeleccionado" style="width: 100%" mobile-breakpoint="0" @change="actualizarTabla">
          <v-tab v-for="tab in arrayTabs" :key="tab.titulo"><v-icon class="mr-2">{{tab.icono}}</v-icon>{{ $t (tab.titulo) }}</v-tab>
        </v-tabs>
      </template>

      <template v-slot:[`item.loc`]="{ item }">
          <span class="localizador">{{ item.loc }}</span>
          <div v-if="item.id_estres != 0" class="estado-reserva">{{ item.id_estres__VT }}</div>
      </template>

      <template v-slot:[`item.lismat`]="{ item }">
        <template v-if="item.lismat">
          <span class="d-flex flex-wrap">
            <span v-for="(matricula, idx) in item.lismat.split (',')" :key="idx" class="matricula">{{ matricula }}</span>
          </span>
        </template>
      </template>

      <template v-slot:default="{ definicionCampos, datosRegistro, accionCrud, esAccionEliminar }">
        <CampoFormularioDatos v-if="accionCrud != 'C'" nombre-campo="fechoralt" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" disabled />
        <CampoFormularioDatos v-if="definicionCampos['id_empinq'].visibilidad==''" nombre-campo="id_empinq" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="accionCrud != 'C'" @change="changeSelectEmpresaInquilina" />
        <CampoFormularioDatos ref="id_pas" nombre-campo="id_pas" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="accionCrud != 'C'" @change="changeSelectPase" />
        <CampoFormularioDatos v-show="datosRegistro['id_pas'] && Object.keys (definicionCampos['id_zon'].dominio_valores).length > 1" ref="id_zon" nombre-campo="id_zon" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" @change="actualizarSelectPlazasDisponibles" />
        <CampoFormularioDatos :min="fechaActual" :max="fechaMaximaInicioReserva" nombre-campo="fechorini" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :ajustar-segundos="0" :ajustar-milisegundos="0" hora-por-defecto="00:00" @change="actualizarSelectPlazasDisponibles" />
        <CampoFormularioDatos :min="fechaMinimaFinReserva" :max="fechaDentroTresMeses" nombre-campo="fechorfin" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" :ajustar-segundos="59" :ajustar-milisegundos="998" hora-por-defecto="23:59" @change="actualizarSelectPlazasDisponibles" />
        <CampoFormularioDatos nombre-campo="obs" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos nombre-campo="plaasi" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
        <CampoFormularioDatos v-if="accionCrud != 'C'" nombre-campo="id_estres" :definicion-campos="definicionCampos" :datos-registro="datosRegistro" :readonly="esAccionEliminar" />
      </template>

    </TablaDatosAPI>

  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";
import CampoFormularioDatos from "@/components/CampoFormularioDatos.vue";
import { DateTime } from "luxon";
import Vue from "vue";
import api from '@/api';

export default {
  components: { TablaDatosAPI,
                CampoFormularioDatos },
  data: () => ({
    arrayTabs: [
      { titulo: "Caducadas", icono: "mdi-calendar-arrow-left", parametro: "filtroCaducadas" },
      { titulo: "Para hoy", icono: "mdi-calendar-today", parametro: "filtroListasParaUsar" },
      { titulo: "Próximas", icono: "mdi-calendar-arrow-right", parametro: "filtroProximas" },
      { titulo: "(Todas)", icono: "mdi-calendar-blank-multiple", parametro: "" },
    ],
    tabSeleccionado: 1,
    dc: {},
    rf: {}
  }),
  methods: {
    actualizarTabla(){
      this.$nextTick (() => {
        this.$refs.tablaReservas.actualizarDatosPorCambiosEnBusqueda();
      });
    },
    antesAbrirFormulario () {
      this.changeSelectEmpresaInquilina ();
    },
    obtenerItemClassTablaDatos (item) {
      if (item.id_estres != 0)
        return "reserva_no_valida";
      else if (DateTime.fromFormat (item.fechorini, "yyyy-MM-dd HH:mm:ss").diffNow() > 0)
        return "reserva_proxima";
       else if (DateTime.fromFormat (item.fechorfin, "yyyy-MM-dd HH:mm:ss").diffNow() < 0)
        return "reserva_caducada";
    },
    changeSelectEmpresaInquilina () {
      this.dc ['id_pas'].dominio_valores = {};
      this.dc ['id_zon'].dominio_valores = {};
      this.inicializarSelectPlazasDisponibles ();

      if (this.rf ['id_empinq']) {
        // debemos actualizar el select de "pases" cada vez que cambiemos el select de "empresa inquilina"
        api.obtenerGestionReservasPases ({ id_empinq: this.rf ['id_empinq'] })
          .then ( (respuesta) => {
            respuesta.data.filas.forEach (fila => {
              this.dc ['id_pas'].dominio_valores [fila.id_pas] = fila.tit;
            });
          })
          .finally (() => {
            this.$refs['id_pas'].actualizarItemsSelect();

            this.$nextTick (() => { // usamos "$nextTick" para ejecutar lo siguiente después de que se hayan actualizado los items del select
              let ids_pases = Object.keys (this.dc ['id_pas'].dominio_valores);
              if (ids_pases.length == 1)
                this.$set (this.rf, 'id_pas', JSON.parse (ids_pases [0]));

              this.changeSelectPase ();
            });
          });
      } else if (this.$refs['id_pas']) {
        this.$refs['id_pas'].actualizarItemsSelect();
        this.$refs['id_zon'].actualizarItemsSelect();
        this.$refs['plaasi'][0].actualizarItemsSelect();
      }
    },
    changeSelectPase () {
      this.dc ['id_zon'].dominio_valores = {};
      this.inicializarSelectPlazasDisponibles ();

      if (this.rf ['id_empinq'] && this.rf ['id_pas']) {
        // debemos actualizar el select de "zonas" cada vez que cambiemos el select de "pase"
        api.obtenerZonasAccesoPase({ id_empinq: this.rf ['id_empinq'], id_pas: this.rf ['id_pas'] })
          .then ( (respuesta) => {
            respuesta.data.filas.forEach (fila => {
              this.dc ['id_zon'].dominio_valores [fila.id_zon] = fila.des + (fila.nomins ? ' - ' + fila.nomins : '');
            });
          })
          .finally (() => {
            this.$refs['id_zon'].actualizarItemsSelect();

            this.$nextTick (() => { // usamos "$nextTick" para ejecutar lo siguiente después de que se hayan actualizado los items del select
              let ids_zonas = Object.keys (this.dc ['id_zon'].dominio_valores);
              if (ids_zonas.length == 1)
                this.$set (this.rf, 'id_zon', JSON.parse (ids_zonas [0]));

              this.actualizarSelectPlazasDisponibles();
            });
          });
      } else if (this.$refs['id_zon']) {
        this.$refs['id_zon'].actualizarItemsSelect();
        this.$refs['plaasi'][0].actualizarItemsSelect();
      }
    },
    inicializarSelectPlazasDisponibles () {
      this.dc ['plaasi'].valores = {};
      this.dc ['plaasi'].valores ['"-"'] = '(Asignar automáticamente)';
    },
    actualizarSelectPlazasDisponibles (){
      this.inicializarSelectPlazasDisponibles ();

      if (this.rf ['id_empinq'] && this.rf ['id_pas'] && this.rf ['id_zon'] && this.rf ['fechorini'] && this.rf ['fechorfin']) {


        api.obtenerGestionReservasPlazasDisponibles({ id_empinq: this.rf ['id_empinq'],
                                                      id_pas: this.rf ['id_pas'],
                                                      id_zon: this.rf ['id_zon'],
                                                      fechorini: this.rf ['fechorini'],
                                                      fechorfin: this.rf ['fechorfin'],
                                                      id_res: this.rf ['id_res'] })
          .then ( (respuesta) => {
            respuesta.data.plazas_disponibles.forEach (plaza => {
              this.dc ['plaasi'].valores [JSON.stringify (plaza)] = plaza;
            });
            if (!respuesta.data.plazas_disponibles.includes (this.rf ['plaasi']))
              this.$set (this.rf, 'plaasi', '-');
          })
          .finally (() => {
            this.$refs['plaasi'][0].actualizarItemsSelect();
          });
      } else if (this.$refs['plaasi']) {
        this.$refs['plaasi'][0].actualizarItemsSelect();
      }
    },
    descripcionCodigoError (codigoError, descripcionError) {
      codigoError = codigoError.toString().toLowerCase();

      if      (codigoError == 'd2e2') return "El pase no es de uso con reserva"; // Pass type is not reservable
      else if (codigoError == 'c193') return "No hay plazas disponibles para reservar"; // Unavailable places
      else if (codigoError == 'f0bc') return "La reserva no puede ser modificada o cancelada"; // Booking cannot be changed or cancelled
      else if (codigoError == 'a269') return "La fecha/hora de inicio de la reserva no es válida"; // Activation date/time not valid
      else if (codigoError == 'c1ac') return "La fecha/hora de fin de la reserva no es válida"; // Expiry date/time not valid
      else if (codigoError == 'ba5a') return "La zona seleccionada no es válida"; // Zone ID not allowed for this pass type
      else if (codigoError == 'bdd3') return "La reserva se solapa con otra"; // The booking overlaps with another
      else if (codigoError == 'db43') return "Se ha alcanzado el número máximo de reservas"; // Maximum number of reservations reached
      else if (codigoError == 'add9') return "La reserva debe realizarse teniendo en cuenta el mínimo de antelación establecido"; // Reservation requirement error (minimum hours in advance)
      else if (codigoError == '5b0c') return "La reserva no se puede realizar con tanta antelación"; // Reservation requirement error (maximum days in advance)
      else if (codigoError == 'ff7' ) return "La reserva supera la duración máxima establecida"; // Reservation requirement error (maximum duration hours)
      else if (codigoError == 'df03') return "La reserva no cumple con el mínimo de días entre reservas"; // Reservation requirement error (minimum days between [previous])
      else if (codigoError == '4c97') return "La reserva no cumple con el mínimo de días entre reservas"; // Reservation requirement error (minimum days between [next])
      else if (codigoError == '8e1c') return "La pre-reserva no se ha encontrado"; // Prebooking not found
      else if (codigoError == '6341') return "La pre-reserva ha caducado"; // Prebooking expired
      else if (codigoError == '5161') return "Pase no encontrado"; // Pass not found
      else if (codigoError == '4e69') return "Zona no encontrada"; // Zone not found
      else
        return descripcionError;
    },
    eventoErrorAPI (error) {
      Vue.prototype.$cuadroDeDialogo.mostrarEx ({
        propsDialog: {
          maxWidth: "500px"
        },
        titulo: {
          estilo: "background: #e28c8c",
          texto: "Error al guardar la reserva",
          icono: { nombre: "mdi-emoticon-sad-outline", props: { large: true } }
        },
        cuerpo: {
          mensajes: [
            { texto: this.descripcionCodigoError (error.data.codigo_error, error.data.error), estilo: "font-family: monospace" },
          ],
          props: { class: "mt-2" }
        },
        acciones: {
          botones: [ { texto: "Aceptar", props: { color: "#e52d2d", text: true } } ]
        }
      });
    }
  },
  computed: {
    permisoEscritura() {
      return this.$store.operador.atributosRol.includes ("gesres");
    },
    parametros() {
      let aux = {};
      if (this.arrayTabs [this.tabSeleccionado].parametro)
        aux [this.arrayTabs [this.tabSeleccionado].parametro] = { valor: 1, descripcion: this.arrayTabs [this.tabSeleccionado].titulo };
      return aux;
    },
    fechaActual() {
      return DateTime.local().toISODate();
    },
    fechaDentroTresMeses() {
      return DateTime.local().plus({ months: 3 }).toISODate();
    },
    fechaMaximaInicioReserva() {
      if (this.rf ['fechorfin'])
        return DateTime.fromFormat (this.rf ['fechorfin'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return this.fechaDentroTresMeses;
    },
    fechaMinimaFinReserva() {
      if (this.rf ['fechorini'])
        return DateTime.fromFormat (this.rf ['fechorini'], "yyyy-MM-dd HH:mm:ss").toISODate();
      else
        return DateTime.local().toISODate();
    }
  },
  created() {
    this.tabSeleccionado = this.$store.leer_preferencia ('tabSeleccionado', 1, 'gestion_reservas');
  },
  watch: {
    tabSeleccionado() {
      this.$store.guardar_preferencia ('tabSeleccionado', this.tabSeleccionado, 1, 'gestion_reservas');
    }
  }
};
</script>

<style>
  .reserva_no_valida {
    color: #AAAAAA;
  }
  .reserva_caducada {
    color: #7E57C2;
  }
  .reserva_proxima {
    color: #689F38;
  }
</style>